import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import actions from './actions'
import mutations from './mutations'
Vue.use(Vuex)
const state = {
  // 用户id
  // userId: '',
  // 定位省份
  locationProvince: '',
  // 定位城市
  locationCity: ''
  // 设备类型
  // deviceType: '',
  // 是否为移动端
  // isPhone: '',
  // 做任务赚积分分享流程 0-初始化 1-点击分享按钮 2-分享成功 3-日超限、月超限分享 4-超限分享成功 5-分享失败
  // shareStatus: 0
}
const store = new Vuex.Store({
  plugins: [createPersistedState({ storage: window.sessionStorage })],
  state,
  actions,
  mutations
})
export default store
